import React from 'react';
// import RouteMapper from '../../components/RouteMap';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import HistoricalHealth from './Components/historical-health';
import CallStatistics from './Components/call-statistics';
import NtmTrace from './Components/ntm-trace';
import ApiResponse from './Components/api-response';
import CallSummary from './Components/call-summary';

const Reports = ({ match, env }) => (
  <Switch>
    <Route
      path={`${match.url}/historical-health`}
      exact
      render={props => <HistoricalHealth {...props} />}
    />
    <Route
      path={`${match.url}/call-statistics`}
      exact
      render={props => <CallStatistics env={env} {...props} />}
    />
    <Route
      path={`${match.url}/ntm-trace`}
      exact
      render={props => <NtmTrace {...props} />}
    />
    <Route
      path={`${match.url}/api-response`}
      exact
      render={props => <ApiResponse {...props} />}
    />
    <Route
      path={`${match.url}/call-summary`}
      exact
      render={props => <CallSummary {...props} />}
    />
  </Switch>
);

Reports.propTypes = {
  match: PropTypes.object.isRequired,
  env: PropTypes.string,
};

Reports.defaultProps = { env: undefined };


export default Reports;
